import { Box } from "@chakra-ui/react";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import config from "config/config";
import { useLanguage } from "contexts/LocalizationContext";
import { useDeviceSize } from "hooks";
import { useRouter } from "next/router";
import type { ReactNode } from "react";
import { isEditMode } from "./Footer.utils";
import { FooterDesktop } from "./FooterDesktop";
import { FooterMobile } from "./FooterMobile";
import type { FooterProps } from "./types";

const setBgImage = (isDesktopXl: boolean) =>
  isDesktopXl ? `url(${config.staticUrl}/i/homepage/decoration-img-triangles-2.svg)` : "none";

const FooterBackground = ({ children, isDesktopXl }: { children: ReactNode; isDesktopXl: boolean }) => (
  <Box background="#f4f6f9" bgImage={setBgImage(isDesktopXl)} bgRepeat="no-repeat" bgPosition="100% 350%">
    {children}
  </Box>
);

export const Footer = ({ footerColumns = [], hideFlagBox }: FooterProps) => {
  const language = useLanguage();
  const { asPath } = useRouter();
  const { isDesktopXl } = useDeviceSize();

  const footerComponent = isDesktopXl ? (
    <FooterDesktop footerColumns={footerColumns} hideFlagBox={hideFlagBox} />
  ) : (
    <FooterMobile footerColumns={footerColumns} hideFlagBox={hideFlagBox} />
  );

  if (isEditMode(asPath, language))
    return <FooterBackground isDesktopXl={isDesktopXl}>{footerComponent}</FooterBackground>;

  return (
    <StickyBottomBarTrigger type="second">
      <FooterBackground isDesktopXl={isDesktopXl}>{footerComponent}</FooterBackground>
    </StickyBottomBarTrigger>
  );
};
